import PIXI from 'pixi.js/src';
import data from './../data/data';
import config from './../config/config';
import renderHelper from './../helpers/render';
import router from './../router/router';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const introView = {
  brLogoSpriteWidth: 200,
  brLogoSpriteHeight: 200,
  uaLogoSpriteWidth: 260,
  uaLogoSpriteHeight: 200,


  /**
   * Sets up the view
   * @param {Object} params - The route params
   * @returns {undefined} undefined
   */
  init(params) {
    this.params = params;

    this.backgroundSquare = new PIXI.Graphics();
    this.backgroundSquare.beginFill(config.blackColor);
    this.backgroundSquare.drawRect(
      0,
      0,
      window.innerWidth,
      window.innerHeight);
    renderHelper.stage.addChild(this.backgroundSquare);

    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    this.brLogoSprite = new PIXI.Sprite(
      PIXI.loader.resources[data.introPaths[0]].texture
    );
    this.brLogoSprite.width = this.brLogoSpriteWidth;
    this.brLogoSprite.height = this.brLogoSpriteHeight;
    this.brLogoSprite.alpha = 0;
    this.graphicsContainer.addChild(this.brLogoSprite);

    this.uaLogoSprite = new PIXI.Sprite(
      PIXI.loader.resources[data.introPaths[1]].texture
    );
    this.uaLogoSprite.width = this.uaLogoSpriteWidth;
    this.uaLogoSprite.height = this.uaLogoSpriteHeight;
    this.uaLogoSprite.alpha = 0;
    this.graphicsContainer.addChild(this.uaLogoSprite);

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
    this.positionGraphics();

    this.animateInOutBrLogo();
  },


  /**
   * Animates in and out the Bleacher Report logo
   * @returns {undefined} undefined
   */
  animateInOutBrLogo() {
    const _this = this;

    this.tween = window.TweenLite.to(
      this.brLogoSprite,
      1,
      {
        autoKill: true,
        alpha: 1,
        ease: window.Linear.easeNone,
      }
    );

    setTimeout(() => {
      _this.tween = window.TweenLite.to(
        this.brLogoSprite,
        1,
        {
          autoKill: true,
          alpha: 0,
          ease: window.Linear.easeNone,
        }
      );
    }, 2000);


    setTimeout(() => {
      _this.animateInOutUaLogo();
    }, 3000);
  },


  /**
   * Animates in and out the Under Armour logo
   * @returns {undefined} undefined
   */
  animateInOutUaLogo() {
    const _this = this;

    this.tween = window.TweenLite.to(
      this.uaLogoSprite,
      1,
      {
        autoKill: true,
        alpha: 1,
        ease: window.Linear.easeNone,
      }
    );

    setTimeout(() => {
      _this.tween = window.TweenLite.to(
        this.uaLogoSprite,
        1,
        {
          autoKill: true,
          alpha: 0,
          ease: window.Linear.easeNone,
        }
      );
    }, 2000);

    setTimeout(() => {
      router.navigate('start');
    }, 3000);
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.brLogoSprite.x = Math.round((window.innerWidth / 2) -
      (this.brLogoSpriteWidth / 2));
    this.brLogoSprite.y = Math.round((window.innerHeight / 2) -
      (this.brLogoSpriteHeight / 2));

    this.uaLogoSprite.x = Math.round((window.innerWidth / 2) -
      (this.uaLogoSpriteWidth / 2));
    this.uaLogoSprite.y = Math.round((window.innerHeight / 2) -
      (this.uaLogoSpriteHeight / 2));
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.backgroundSquare);
    renderHelper.stage.removeChild(this.graphicsContainer);
  },
};

export default introView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/intro.js
 **/